import { Flex, Text, TextInput, ActionIcon } from '@mantine/core';
import { IconPencil } from '@tabler/icons-react';
import { useEffect, useState } from 'react';

export interface TariffTimeEditorProps {
  rowID: string;
  startTime: string;
  endTime: string;
  isEditingStart: boolean;
  isEditingEnd: boolean;
  setEditingStartTimeId: (id: string | null) => void;
  setEditingEndTimeId: (id: string | null) => void;
  handleStartTimeChange: (rowID: string, timeValue: string) => void;
  handleEndTimeChange: (rowID: string, timeValue: string) => void;
}

const compactInputStyles = {
  input: {
    minHeight: 38,
    paddingInline: 8,
  },
};

export const TariffTimeEditor = ({
  rowID,
  startTime,
  endTime,
  isEditingStart,
  isEditingEnd,
  setEditingStartTimeId,
  setEditingEndTimeId,
  handleStartTimeChange,
  handleEndTimeChange,
}: TariffTimeEditorProps) => {
  const [startTimeInput, setStartTimeInput] = useState(startTime);
  const [endTimeInput, setEndTimeInput] = useState(endTime);

  useEffect(() => {
    setStartTimeInput(startTime);
  }, [startTime]);

  useEffect(() => {
    setEndTimeInput(endTime);
  }, [endTime]);

  if (isEditingStart || isEditingEnd) {
    return (
      <Flex gap={4} align="center" w="100%">
        <TextInput
          data-testid="start-time-input"
          value={startTimeInput}
          placeholder="HH:mm"
          size="sm"
          w={62}
          autoFocus={isEditingStart}
          inputMode="numeric"
          maxLength={5}
          onChange={(event) => {
            const value = event.currentTarget.value;
            setStartTimeInput(value);
            handleStartTimeChange(rowID, value);
          }}
          onBlur={() => setEditingStartTimeId(null)}
          styles={compactInputStyles}
        />
        <Text size="xs" c="dimmed">
          -
        </Text>
        <TextInput
          data-testid="service-end-input"
          value={endTimeInput}
          placeholder="HH:mm"
          size="sm"
          w={62}
          autoFocus={isEditingEnd}
          inputMode="numeric"
          maxLength={5}
          onChange={(event) => {
            const value = event.currentTarget.value;
            setEndTimeInput(value);
            handleEndTimeChange(rowID, value);
          }}
          onBlur={() => setEditingEndTimeId(null)}
          styles={compactInputStyles}
        />
      </Flex>
    );
  }

  return (
    <Flex align="center" w="100%" gap={6}>
      <Text
        fw={600}
        style={{ cursor: 'pointer', fontVariantNumeric: 'tabular-nums' }}
        onClick={() => setEditingStartTimeId(rowID)}
      >
        {startTime}
      </Text>
      <Text size="xs" c="dimmed">
        -
      </Text>
      <Text
        fw={600}
        style={{ cursor: 'pointer', fontVariantNumeric: 'tabular-nums' }}
        onClick={() => setEditingEndTimeId(rowID)}
      >
        {endTime}
      </Text>
      <ActionIcon
        onClick={() => setEditingStartTimeId(rowID)}
        variant="transparent"
      >
        <IconPencil size={14} color="var(--mantine-color-dimmed)" />
      </ActionIcon>
    </Flex>
  );
};
